import ApiClient from '@/api/ApiClient';
import { MessageOkResponse, SchoolDiaryResponse } from 'chaild-api/lib';
import {
  ApproveSchoolDiaryRequest,
  ChangeSchoolDiaryRequest,
  ExportSchoolDiaryRequest,
  GetSchoolDiaryRequest,
  PostSchoolDiaryRequest,
  SearchSchoolDiaryRequest,
} from '@/model/Request';

export default class ApiSchoolDiary {
  // GET: 園日誌取得
  public static async getSchoolDiary(
    input: GetSchoolDiaryRequest
  ): Promise<SchoolDiaryResponse> {
    try {
      return await ApiClient.get(
        `/nursery/${input.nurseryId}/diary`,
        { date: input.date }
      );
    } catch (error) {
      throw error;
    }
  }

  // POST: 園日誌作成
  public static async postSchoolDiary(
    input: PostSchoolDiaryRequest
  ): Promise<SchoolDiaryResponse> {
    try {
      return await ApiClient.post(
        `/nursery/${input.nurseryId}/diary`,
        {
          date: input.date,
          comment: input.comment,
          event: input.event,
          earlyLeaver: input.earlyLeaver,
          status: input.status,
          appliedBy: input.appliedBy,
        }
      );
    } catch (error) {
      throw error;
    }
  }

  // PUT: 園日誌更新
  public static async putSchoolDiary(
    input: ChangeSchoolDiaryRequest
  ): Promise<SchoolDiaryResponse> {
    try {
      return await ApiClient.put(
        `/nursery/${input.nurseryId}/diary/${input.diaryId}`,
        {
          comment: input.comment,
          event: input.event,
          earlyLeaver: input.earlyLeaver,
          status: input.status,
          appliedBy: input.appliedBy,
        }
      );
    } catch (error) {
      throw error;
    }
  }

  // DELETE: 園日誌削除
  public static async deleteSchoolDiary(
    input: ChangeSchoolDiaryRequest
  ): Promise<MessageOkResponse> {
    try {
      return await ApiClient.delete(
        `/nursery/${input.nurseryId}/diary/${input.diaryId}`,
        null
      );
    } catch (error) {
      throw error;
    }
  }

  // PUT: 園日誌の承認状態更新
  public static async approveSchoolDiary(
    input: ApproveSchoolDiaryRequest
  ): Promise<SchoolDiaryResponse> {
    try {
      return await ApiClient.put(
        `/nursery/${input.nurseryId}/diary/${input.diaryId}/approval`,
        { approvalStatus: input.approvalStatus }
      );
    } catch (error) {
      throw error;
    }
  }

  // POST: 園日誌のExcel出力
  public static async exportSchoolDiary(
    input: ExportSchoolDiaryRequest
  ): Promise<{ url: string }> {
    try {
      return await ApiClient.post(
        `/nursery/${input.nurseryId}/diary/excel`,
        { from: input.from, to: input.to }
      );
    } catch (error) {
      throw error;
    }
  }

  // GET: 園日誌の検索
  public static async searchSchoolDiary(
    input: SearchSchoolDiaryRequest
  ): Promise<{ diaries: SchoolDiaryResponse[]; totalItemsCount: number }> {
    try {
      return await ApiClient.get(
        `/nursery/diary/search`,
        { nurseryId: input.nurseryId, limit: input.limit, skip: input.skip }
      );
    } catch (error) {
      throw error;
    }
  }
}
